import { MagnifyingGlass } from '@creditornot/cb-icons';
import { Input } from '@creditornot/cb-input';
import React, { ChangeEvent, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import useDebounceString from 'common/hooks/useDebounceString';

import SearchResults from './SearchResults/SearchResults';
import UserEntityList from './UserEntityList';
import useSearch from './hooks/useSearch';
import { isValidSearchQuery } from './utils';

const StyledSearchInput = styled(Input)`
  width: 648px;
`;

const EntitySearch = () => {
  const [searchString, setSearchString] = useState('');
  const debouncedSearchString = useDebounceString(searchString);
  const isSearchEnabled = isValidSearchQuery(searchString);

  const {
    brands,
    enterprises,
    isLoading: isSearching,
    merchants,
    venues,
  } = useSearch(debouncedSearchString, isSearchEnabled);

  const intl = useIntl();

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => setSearchString(e.target.value);

  return (
    <>
      <StyledSearchInput
        icon={<MagnifyingGlass />}
        placeholder={intl.formatMessage({ id: 'merchantSearch.searchForMerchants' })}
        type="text"
        value={searchString}
        onChange={handleSearch}
      />
      {isSearchEnabled ? (
        <SearchResults
          enterprises={enterprises}
          isLoading={isSearching}
          merchants={merchants}
          venues={venues}
          brands={brands}
        />
      ) : (
        <UserEntityList />
      )}
    </>
  );
};

export default EntitySearch;
